module.exports = __webpack_public_path__ + "static/media/cort-furniture.775b6212.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/cort-furniture.jpg
// module id = 759
// module chunks = 27